import { InvoiceSourceType } from "@mimber/schema"

export const SOURCE_TYPE_OPTIONS = [
  { label: "Custom", value: InvoiceSourceType.CUSTOM },
  { label: "Dues", value: InvoiceSourceType.MEMBERSHIP_TIER },
  { label: "Donation", value: InvoiceSourceType.DONATION },
]
